import { TOrderCreate } from '@@types/order';
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '@stores/store';

export type TOrderInitialState = Partial<TOrderCreate> | {};

const initialState: TOrderInitialState = {};

export const orderSelector = (state: RootState) =>
  state.order as Partial<TOrderCreate>;

export const popupSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    storeOrderInfo: (state, action) => {
      state = {
        ...state,
        ...action.payload,
      };
      return state;
    },
    initOrderInfo: (state, action) => {
      const target = action.payload.key;
      if (target) {
        let returnState = { ...state };
        returnState[target as keyof TOrderCreate] = undefined;
        return returnState;
      }
      state = {};
      return state;
    },
    storeOrderAddressInfo: (state, action) => {
      state = {
        ...state,
        address: {
          ...((state as any).address || {}),
          ...action.payload,
        },
      };
      return state;
    },
  },
});

export const { storeOrderInfo, initOrderInfo, storeOrderAddressInfo } =
  popupSlice.actions;

export default popupSlice.reducer;
